// import 'babel-polyfill';
// import 'angular';
// import 'angular-animate';
// import 'cian-ui/dist/cian-ui.min.css';

import './serp/serp';


// WEBPACK FOOTER //
// ./src/serp-entry.js